import { Component, ChangeDetectorRef, AfterViewInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SearchPersonInputService } from './search-person-input.service';
import { Person } from 'src/app/models/person';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
    selector: 'search-person-input',
    templateUrl: './search-person-input.component.html',
    styleUrls: ['./search-person-input.component.scss'],
})
export class SearchPersonInputComponent implements AfterViewInit {
    people: Person[] = [];
    peopleLoading = false;
    selectedPersonId: any;
    isOpen: boolean = false;
    search: boolean = true;

    @ViewChild('selectElement') SelectElement!: NgSelectComponent;

    @Input() searchType!: SearchTypeEnum;
    @Input() filterName: string = '';
    @Output() personSelectedId = new EventEmitter<any>();

    constructor(private searchPersonInputService: SearchPersonInputService, private cdRef: ChangeDetectorRef) {}

    ngAfterViewInit(): void {
        this.setInitialFilterName();
    }

    setInitialFilterName(): void {
        if (this.SelectElement && this.filterName) {
            const input = this.SelectElement.element.querySelector('input');
            if (input) {
                input.value = this.filterName;
                this.searchPerson();
            }
        }
    }

    outSelect(ev: any) {
        this.clearInput();
        this.personSelectedId.emit(ev);
        this.SelectElement.blur();
    }

    onSearch(event: { term: string }) {
        this.filterName = event.term;
    }

    clearInput() {
        this.isOpen = false;
        this.filterName = '';
    }

    searchPerson(): void {
        this.search = true;
        this.people = [];
        if (this.filterName.length > 3) {
            this.getPersonConfig(this.filterName);
        }
    }

    keydownConfigAuto(event: any) {
        this.filterName = (event.target as HTMLInputElement).value;
        this.search = true;
        // //enter
        if (event.keyCode === 13) {
            this.people = [];
            this.searchPerson();
        }
    }

    getPersonConfig(name: string) {
        this.peopleLoading = true;
        this.searchPersonInputService.getPerson(name, this.searchType).subscribe((res) => {
            this.people = res.data;
            this.isOpen = true;
            clearTimeout(1);
            this.search = false;
            this.peopleLoading = false;
            this.cdRef.detectChanges();
        });
    }
}

export enum SearchTypeEnum {
    PersonDocument,
    PersonContract,
}
